/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OpenAI } from '../models/OpenAI';
import type { OpenAIPrompt } from '../models/OpenAIPrompt';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PromptService {

    /**
     * Get Prompt
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPromptApiV1OpenaiPromptGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/V1/openai/prompt',
        });
    }

    /**
     * Put Prompt
     * @param requestBody
     * @returns OpenAI Successful Response
     * @throws ApiError
     */
    public static putPromptApiV1OpenaiPromptPut(
        requestBody: OpenAIPrompt,
    ): CancelablePromise<OpenAI> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/V1/openai/prompt',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reset Prompt
     * @returns OpenAI Successful Response
     * @throws ApiError
     */
    public static resetPromptApiV1OpenaiPromptOptions(): CancelablePromise<OpenAI> {
        return __request(OpenAPI, {
            method: 'OPTIONS',
            url: '/api/V1/openai/prompt',
        });
    }

}
